import { useQueryApi } from "api/hooks.ts";
import { ApiResponse } from "types/models.ts";

import { sanctumApi } from "./api";

// Hook to get CSRF cookie
export const useGetCsrfCookieQuery = (options = {}) => {
    return useQueryApi<ApiResponse<null>>({
        queryKey: ["getCsrfCookie"],
        queryFn: () => sanctumApi.getCsrfCookie(),
        ...options,
    });
};
